import React from "react";

export default function ResourceContactDetail({ header, contactDetails }) {
  return header ? (
    <div>
      <h4>{header}</h4>
      <ul className="resultCard-contact">
        {contactDetails.map(({ contact, distance, bcWide }, idx) => {
          if (!contact) return null;
          if (contact.type === "Website") {
            return (
              <li key={idx} className="icon-site">
                <a href={`https://${contact.url}`} target="_blank">
                  {contact.url}
                </a>
              </li>
            );
          } else if (contact.type === "PostalAddress" || contact.type === "PhysicalLocation") {
            //  TODO: confirm parity with contact.twig
            const fullAddress =
              contact.line1 && contact.line1.indexOf("n/a") == -1
                ? `${contact.line1}, ${contact.line2 ? contact.line2 + "," : ""}<br/>${
                    contact.city
                  }, ${contact.stateProvince} ${contact.zipPostalCode ? contact.zipPostalCode : ""}`
                : `No ${contact.type === "PostalAddress" ? "mailing" : ""} address available`;
            return (
              <li key={idx} className={`icon-${contact.type === "PostalAddress" ? "post" : "pin"}`}>
                <span dangerouslySetInnerHTML={{ __html: fullAddress }} />
                {distance && fullAddress.indexOf("No ") == -1 && (
                  <>
                    <br />
                    {bcWide ? (
                      <span className="italic">Serves all of BC</span>
                    ) : (
                      <span className="bold">{`~${Math.round(distance * 10) / 10} km away`}</span>
                    )}
                  </>
                )}
              </li>
            );
          }
        })}
      </ul>
    </div>
  ) : (
    <>
      {contactDetails.map(({ contact }, idx) => {
        if (!contact) return null;
        if (contact.type === "EmailAddress") {
          return (
            <li key={idx} className="icon-email">
              <strong>{contact.label == "Main" ? "Email" : contact.label}:</strong>{" "}
              <a href={`mailto:${contact.address}`}>{contact.address}</a>
            </li>
          );
        } else if (contact.type === "PhoneNumber") {
          const isPhone = contact.purpose !== "Fax";
          return contact.number.indexOf("none") < 0 ? (
            <li key={idx} className={`icon-${isPhone ? "phone" : "fax"}`}>
              <strong>{contact.label}:</strong>{" "}
              {isPhone ? <a href={`tel:${contact.number}`}>{contact.number}</a> : contact.number}
            </li>
          ) : (
            <span>No contact information available</span>
          );
        }
      })}
    </>
  );
}
